/**
 * @method getErrorMessage() - Method to get error message
 * @param error - any 
**/
export const getErrorMessage = (error: any): string => {
  if (error instanceof Error) {
    return error?.message;
  }

  if(typeof error === "string"){
    return error;
  }
  
  return "Something went wrong";
};
